import React from 'react';
import _ from 'lodash';

import styles from './reschedule-technician-form-placeholder.module.scss';

export const RescheduleTechnicianFormPlaceholder = () => {
    const renderInputFields = (numberOfInputs: number) => (
        <div>
            <div className={styles.title} />
            {_.range(numberOfInputs).map((index) => (
                <div key={index}>
                    <div className={styles.label} />
                    <div className={styles.input} />
                </div>
            ))}
        </div>
    );

    return (
        <div className={styles.container}>
            <div>
                {_.range(2).map((index) => (
                    <div className={styles.heading} key={index} />
                ))}
            </div>
            {renderInputFields(2)}
            <div className={styles.spacing} />
            {renderInputFields(4)}
            {_.range(2).map((index) => (
                <div className={styles.checkboxContainer} key={index}>
                    <div className={styles.checkbox} />
                    <div className={styles.textContainer}>
                        <div className={styles.text} />
                        <div className={styles.text} />
                    </div>
                </div>
            ))}
            <div className={styles.button} />
        </div>
    );
};
